import { useCallback } from 'react';

import type { SymbolKey } from '@/entities/symbol';
import {
  addSymbols,
  clearSelection,
  deleteSymbols,
  reorderSymbols,
  setSymbols
} from '@/features/SymbolSelector/store/symbolSelector.slice';
import { useAppDispatch } from '@/hooks/redux-hooks';

export const useSelectedSymbolsActions = () => {
  const dispatch = useAppDispatch();

  const addSelectedSymbols = useCallback(
    (symbols: SymbolKey[]) => {
      dispatch(addSymbols({ symbols }));
    },
    [dispatch]
  );

  const removeSelectedSymbols = useCallback(
    (symbols: SymbolKey[]) => {
      dispatch(deleteSymbols({ symbols }));
    },
    [dispatch]
  );

  const reorderSelectedSymbols = useCallback(
    (symbols: SymbolKey[]) => {
      dispatch(reorderSymbols({ symbols }));
    },
    [dispatch]
  );

  const clearSelectedSymbols = useCallback(() => {
    dispatch(clearSelection());
  }, [dispatch]);

  const setSelectedSymbols = useCallback(
    (symbols: SymbolKey[]) => {
      dispatch(setSymbols(symbols));
    },
    [dispatch]
  );

  return {
    addSelectedSymbols,
    removeSelectedSymbols,
    reorderSelectedSymbols,
    clearSelectedSymbols,
    setSelectedSymbols
  };
};
